/**
 * Mock data for the operations "Suggested Promotion" page — the acquisition
 * SuggestedCampaign template with operations copy/channels.
 * Temporary — remove when wired to an API (see docs/mock-data.md).
 */
import type { SuggestedCampaignData } from './types';

const ART_1 = '/assets/marketing/campaign-spooky-1.png';
const ART_2 = '/assets/marketing/campaign-spooky-2.png';

export const operationsSuggestedPromotionData: SuggestedCampaignData = {
  header: { title: 'Suggested Promotion Details' },
  periodLabel: 'Campaign Duration: October 22 - October 30',
  intro: 'Keep loyal players engaged with a timely birthday promo.',
  offering: {
    title: '100 Free Spooky Spins',
    badge: { label: 'Free campaign', tone: 'success' },
    description:
      'Celebrating together with a spooky treat: 100 Free Spins for your loyal players. A timely promotion to keep them engaged and coming back for more.',
    channelsLabel: 'Activate this promotion to advertise to players via:',
    channels: [
      { id: 'email', label: 'Email Newsletters' },
      { id: 'sms', label: 'SMS Messages' },
      { id: 'push', label: 'Push Notifications' },
    ],
    moreCount: 10,
  },
  styleStep: {
    options: [
      { id: 'option-1', label: 'OPTION 1', image: ART_1 },
      { id: 'option-2', label: 'OPTION 2', image: ART_2 },
    ],
  },
  warning: 'This campaign will become outdated in just 8 hours.',
};

export default operationsSuggestedPromotionData;
